import React, { useLayoutEffect, forwardRef } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

const PageWrapperLogin = forwardRef(({ description, className, children }, ref) => {
	useLayoutEffect(() => {
		document.getElementsByTagName('TITLE')[0].text = 'Domus';
		document
			.querySelector('meta[name="description"]')
			.setAttribute('content', description || process.env.REACT_APP_META_DESC);
	});

	return (
		<div
			ref={ref}
			className={classNames('page-wrapper', 'container-fluid', className)}
			style={{ background: 'linear-gradient(#231B65, #231B65, #151E86, #231B65)' }}>
			{children}
		</div>
	);
});
PageWrapperLogin.propTypes = {
	description: PropTypes.string,
	children: PropTypes.node.isRequired,
	className: PropTypes.string,
};
PageWrapperLogin.defaultProps = {
	description: null,
	className: null,
};

export default PageWrapperLogin;
